import { render, staticRenderFns } from "./MySiderLayout.vue?vue&type=template&id=48009496"
import script from "./MySiderLayout.vue?vue&type=script&lang=js"
export * from "./MySiderLayout.vue?vue&type=script&lang=js"
import style0 from "./MySiderLayout.vue?vue&type=style&index=0&id=48009496&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports